<div class="modal-dark">
  <div class="modal-header">
    <h4 class="modal-title">Export {{ isExportingPayments() ? 'payment' : 'deposit' }} transactions</h4>
  </div>
  <div class="modal-body">
    <p>
      Are you sure you want to export all your {{ isExportingPayments() ? 'payment' : 'deposit' }} transactions?<br />
      @if (isExportingPayments()) {
        You can apply
        <button
          (click)="openExport()"
          class="btn btn-link px-0 min-w-100">
          filters
        </button>
        to your export.
      }
    </p>
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-outline-dark"
      aria-label="Close"
      (click)="onCancel()">
      Cancel
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      (click)="onAccept()">
      Export all
    </button>
  </div>
</div>
